<template>
  <v-row>

    fsdff
  </v-row>
</template>

<script>
export default {
  name: 'ProfileSuccess',
  data () {
    return {
      loading: true,
      error: null
    }
  },
  mounted() {

  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    successId () {
      return this.$route.query.id
    }
  },
  methods: {

  }
}
</script>